import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loading-margin-point',
  templateUrl: './loader-mp.component.html',
  styleUrls: ['./loader-mp.component.scss']
})
export class LoadingMarginPointComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit() {
    this.router.navigate(['/fs-lite'])
  }

}
